/*
 * @Descripttion: 
 * @version: 
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2025-07-15 14:10:47
 * @LastEditors: linxi
 * @LastEditTime: 2025-07-15 15:47:10
 */
/*
 * @Descripttion: 
 * @version: 
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2025-07-14 16:47:03
 * @LastEditors: linxi
 * @LastEditTime: 2025-07-15 09:42:33
 */
import { createAsyncThunk } from "@reduxjs/toolkit";
import _ from "lodash";
import { sendAsync } from "../../../app/applicationSlice";
import { RootThunkApi } from "../../../app/store";
import { getDrugQualityFileList,DrugQualityFileListParams, getDrugQualityFileDetail, getDrugQualityFileSubmit, SubmitParams, getDrugQualityFileExport, getRemove, getBatchDrugQualityFileSubmit } from "../../../services/drugQualityFile";

// 列表
export const getDrugQualityFileListAsync = createAsyncThunk<
  void,
  DrugQualityFileListParams,
  RootThunkApi<void>
>('drugQualityFile/getDrugQualityFileListAsync', async (params, api) => {
  return sendAsync(getDrugQualityFileList(params), api)
})


// 详情
export const getDrugQualityFileDetailAsync = createAsyncThunk<void, any, RootThunkApi<void>>(
  'drugQualityFile/getDrugQualityFileDetailAsync',
  async (params, api) => {
    return sendAsync(getDrugQualityFileDetail(params), api)
  }
)


// 保存编辑
export const getDrugQualityFileSubmitAsync = createAsyncThunk<
  void,
  SubmitParams,
  RootThunkApi<void>
>(
  'drugQualityFile/getDrugQualityFileSubmitAsync',
  async (params, api) => {
    return sendAsync(getDrugQualityFileSubmit(params), api)
  }
)

export const getBatchDrugQualityFileSubmitAsync = createAsyncThunk<
  void,
  SubmitParams,
  RootThunkApi<void>
>(
  'drugQualityFile/getBatchDrugQualityFileSubmitAsync',
  async (params, api) => {
    return sendAsync(getBatchDrugQualityFileSubmit(params), api)
  }
)


//导出
export const getDrugQualityFileExportAsync = createAsyncThunk<
  void,
  DrugQualityFileListParams,
  RootThunkApi
>('drugQualityFile/getDrugQualityFileExportAsync ', async (params, api) => {
  return sendAsync(getDrugQualityFileExport(params), api)
})


// 删除
export const getRemoveAsync = createAsyncThunk<void, any, RootThunkApi<void>>(
  'drugQualityFile/getRemoveAsync',
  async (params, api) => {
    return sendAsync(getRemove(params), api)
  }
)
